import { useGetFeatures } from '@/queries/premium/useGetFeatures'
import { usePremiumFeaturesStore } from '@/stores/permissions/premiumFeatures'
import { useEffect } from 'react'

export function usePremiumFeaturesFetcher() {
  const { data } = useGetFeatures()
  const { actions } = usePremiumFeaturesStore()

  useEffect(() => {
    if (data) {
      actions.setPremiumFeatures(data.features)
      actions.setStatus(data.status)
      actions.setHasUpgrade(data.hasUpgrade)
      if (data.accountCreatedAt) actions.setAccountCreatedAt(new Date(data.accountCreatedAt))
      if (data.paymentIssue) actions.setPaymentIssue(data.paymentIssue)
    }
  }, [actions, data])
}
